import { render, staticRenderFns } from "./DHL.vue?vue&type=template&id=27ce71a0&scoped=true"
import script from "./DHL.vue?vue&type=script&lang=js"
export * from "./DHL.vue?vue&type=script&lang=js"
import style0 from "./DHL.vue?vue&type=style&index=0&id=27ce71a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce71a0",
  null
  
)

export default component.exports